export default __webpack_public_path__ + "static/media/clout.5039064d.png";